import styled from 'styled-components'

export const StyledUserManagement = styled.div``
